const REPORT_PRODUCT_SERIES = ['certificates', 'signatures', 'archive'];

function normalizedIds(values) {
  return Array.isArray(values) ? values.map(String) : [];
}

function dimensionIsRestricted(mode, ids) {
  return mode !== 'all' && normalizedIds(ids).length > 0;
}

function optionsForMode(options, mode, ids, identifier) {
  const values = Array.isArray(options) ? options : [];
  const selected = new Set(normalizedIds(ids));
  if (mode === 'all' || selected.size === 0) return values;
  return values.filter(option => (
    mode === 'include'
      ? selected.has(String(identifier(option)))
      : !selected.has(String(identifier(option)))
  ));
}

/**
 * Resolve the product families represented by the applied report filters.
 *
 * This consumes normalized catalogue options rather than draft form state so
 * chart controls always describe the same scope as the loaded API result.
 */
function resolveReportChartSeriesScope(filters, catalogs) {
  const applied = filters || {};
  const options = catalogs || {};
  const restricted = dimensionIsRestricted(applied.productGroupMode, applied.productGroupIds)
    || dimensionIsRestricted(applied.productMode, applied.productIds);

  if (!restricted) {
    return { keys: REPORT_PRODUCT_SERIES, restricted: false };
  }

  const products = Array.isArray(options.products) ? options.products : [];
  const productGroups = Array.isArray(options.productGroups) ? options.productGroups : [];
  if (products.length === 0 && productGroups.length === 0) {
    // Catalogue loading is optional, but a restricted request must never
    // broaden back to all families. The chart can resolve this scope from the
    // already-filtered report payload; without either source it fails closed.
    return { keys: [], restricted: true, unresolved: true };
  }

  if (dimensionIsRestricted(applied.productMode, applied.productIds) && products.length === 0) {
    return { keys: [], restricted: true, unresolved: true };
  }

  const groupScopedProducts = optionsForMode(
    products,
    applied.productGroupMode,
    applied.productGroupIds,
    option => option.groupId
  );
  const scopedProducts = optionsForMode(
    groupScopedProducts,
    applied.productMode,
    applied.productIds,
    option => option.value
  );
  let categories = new Set(scopedProducts.map(option => option.categoryKey).filter(Boolean));

  // Some catalogue groups can legitimately have no products. Group-only
  // scopes can still be mapped from their parent business family.
  if (categories.size === 0 && !dimensionIsRestricted(applied.productMode, applied.productIds)) {
    const scopedGroups = optionsForMode(
      productGroups,
      applied.productGroupMode,
      applied.productGroupIds,
      option => option.value
    );
    categories = new Set(scopedGroups.map(option => option.categoryKey).filter(Boolean));
  }

  return {
    keys: REPORT_PRODUCT_SERIES.filter(key => categories.has(key)),
    restricted: true
  };
}

export { REPORT_PRODUCT_SERIES, resolveReportChartSeriesScope };
